import * as React from 'react'

function CarIcon(props) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.333 12l-3.493 1.333M6.173 13.333L2.667 12M24.333 18.667H21M11 18.667H7.667M25.839 13.333L24.72 7.984a3.335 3.335 0 00-3.264-2.65H10.683a3.333 3.333 0 00-3.246 2.574L6.17 13.333"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.333 26.667h3a2 2 0 002-2v-1.334h13.334v1.334a2 2 0 002 2h3c.92 0 1.666-.747 1.666-1.667v-7.667a4 4 0 00-4-4H6.667a4 4 0 00-4 4V25c0 .92.746 1.667 1.666 1.667z"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { CarIcon }
